import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from '../environments/environment';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { HomeComponent } from './screens/home/home.component';
import { HeaderComponent } from './screens/header/header.component';
import { FooterComponent } from './screens/footer/footer.component';
import { ShowcaseComponent } from './screens/home/showcase/showcase.component';
import { CounterComponent } from './screens/home/counter/counter.component';
import { BulletinComponent } from './screens/home/bulletin/bulletin.component';
import { VisionMissionComponent } from './screens/home/vision-mission/vision-mission.component';
import { MessagesComponent } from './screens/home/messages/messages.component';
import { CoursesComponent } from './screens/home/courses/courses.component';
import { EventsComponent } from './screens/home/events/events.component';
import { WhyComponent } from './screens/home/why/why.component';
import { CampusLifeComponent } from './screens/home/campus-life/campus-life.component';
import { AlumniComponent } from './screens/home/alumni/alumni.component';
import { SharedModule } from './modules/shared/shared.module';
import { LazyMenuModule } from './lazy-menu/lazy-menu.module';
import { QuickLinksComponent } from './screens/home/quick-links/quick-links.component';
import { NoticeCircularComponent } from './screens/home/notice-circular/notice-circular.component';
import { StudentParentHubComponent } from './screens/home/student-parent-hub/student-parent-hub.component';
import { CertificateCtaComponent } from './screens/home/certificate-cta/certificate-cta.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    ShowcaseComponent,
    CounterComponent,
    BulletinComponent,
    VisionMissionComponent,
    MessagesComponent,
    CoursesComponent,
    EventsComponent,
    WhyComponent,
    CampusLifeComponent,
    AlumniComponent,
    QuickLinksComponent,
    NoticeCircularComponent,
    StudentParentHubComponent,
    CertificateCtaComponent,


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    CarouselModule,
    PdfViewerModule,
    SharedModule,
    LazyMenuModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
